import { render, staticRenderFns } from "./exchange-record.vue?vue&type=template&id=c9bd67ae&"
import script from "./exchange-record.vue?vue&type=script&lang=js&"
export * from "./exchange-record.vue?vue&type=script&lang=js&"
import style0 from "./exchange-record.vue?vue&type=style&index=0&module=true&lang=less&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports